var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{class:`dimensions-logo-${_vm.sizing}`,attrs:{"src":_setup.imageUrl,"alt":"TrustPilot Logo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }